import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import GrainIcon from "@material-ui/icons/Grain";

import getPath from "./getPath";

const useStyles = makeStyles((theme) => ({
  link: {
    display: "flex",
    color: "gray",
    fontSize: "0.8em",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
}));

function handleClick(event) {
  event.preventDefault();
  // console.info("You clicked a breadcrumb.");
}

// TODO
// Figure out for what this is needed?

export default function GPAP_Breadcrumb() {
  const classes = useStyles();

  const SUBMISSION =
    window.location.href.includes("submission") ||
    window.location.href.includes("submit");

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link
        color="textPrimary"
        href="/"
        onClick={handleClick}
        className={classes.link}
      >
        <HomeIcon className={classes.icon} />
        Home
      </Link>
      <Link
        color="textPrimary"
        href="#/submission"
        onClick={handleClick}
        className={classes.link}
      >
        <CloudUploadIcon className={classes.icon} />
        {SUBMISSION ? "Data Submission" : "Data Management"}
      </Link>
      <Typography color="textPrimary" className={classes.link}>
        <GrainIcon className={classes.icon} />
        {getPath(window.location.hash)}
      </Typography>
    </Breadcrumbs>
  );
}
